import { useMediaQuery } from '@material-ui/core';

const mobileIOS = navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/);

const mobileQuery = mobileIOS ? '(max-width: 500px)' : '(orientation: portrait)';

export default function usePortraitOrientation() {
  const portrait = useMediaQuery(mobileQuery);

  return portrait;
}
